import BaseLoading from '@/src/components/helpers/base-loading/base-loading'
import ImageFallback from '@/src/components/helpers/image-fallback/image-fallback'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import { useCurrentProduct } from '@/src/context/product/current-product-context'
import React, { useState } from 'react'
import styles from './styles.module.scss'
import SvgShare from '@/src/assets/svgs/collection/share-2.svg'
import ShareButtons from '@/src/components/misc/share-buttons/share-buttons'
import BackButton from '@/src/components/misc/back-button/back-button'
import { Overlay } from '@/src/components/helpers/overlays/overlay'

export default function ProductImage() {
    const { merchantSummary } = useMerchant()
    const { currentProduct, isLoading } = useCurrentProduct()

    const [openModal, setOpenModal] = useState(false)

    let productPhoto = (currentProduct?.hasPhoto && merchantSummary?.showProductPhoto)
        ? `//${currentProduct.images[0]?.largeImageUrl}`
        : ''

    let productDescription = merchantSummary?.showProductDescription
        ? currentProduct?.description
        : ""

    return (
        <>
            {
                openModal &&
                <ShareButtons
                    title={currentProduct?.name ?? merchantSummary?.name!}
                    text={productDescription}
                    url={window.location.href}
                    isOpen={openModal}
                    setIsOpen={setOpenModal}
                    copyText='Link copiado!'
                />
            }
            {
                isLoading
                    ?
                    <BaseLoading>
                        <aside className={styles.imageContainer} />
                    </BaseLoading>
                    :
                    <div className={styles.imageContainer}>
                        <BackButton onClick={() => Overlay.dismiss()} className={styles.backBtn} />
                        {
                            <ImageFallback
                                src={productPhoto}
                                alt={''}
                                className={styles.image}
                            />
                        }
                        <div onClick={() => setOpenModal(true)} className={styles.shareArea}>
                            <SvgShare />
                        </div>
                    </div>
            }
        </>
    )
}
